export default {
  "pages.layouts.userLayout.title":
    "Professional barcode management system for Eatsy platform",
  "pages.login.accountLogin.tab": "Account Login",
  "pages.login.accountLogin.errorMessage":
    "Incorrect username/password(admin/ant.design)",
  "pages.login.failure": "Login failed, please try again!",
  "pages.login.success": "Login successful!",
  "pages.login.username.placeholder": "Username: admin or user",
  "pages.login.username.required": "Please input your username!",
  "pages.login.email.placeholder": "Email address",
  "pages.login.email.required": "Please enter your email address!",
  "pages.login.email.invalid": "Please enter a valid email address!",
  "pages.login.password.placeholder": "Password: ant.design",
  "pages.login.password.required": "Please input your password!",
  "pages.login.phoneLogin.tab": "Phone Login",
  "pages.login.phoneLogin.errorMessage": "Verification Code Error",
  "pages.login.phoneNumber.placeholder": "Phone Number",
  "pages.login.phoneNumber.required": "Please input your phone number!",
  "pages.login.phoneNumber.invalid": "Phone number is invalid!",
  "pages.login.captcha.placeholder": "Verification Code",
  "pages.login.captcha.required": "Please input verification code!",
  "pages.login.phoneLogin.getVerificationCode": "Get Code",
  "pages.getCaptchaSecondText": "sec(s)",
  "pages.login.rememberMe": "Remember me",
  "pages.login.forgotPassword": "Forgot Password ?",
  "pages.login.submit": "Login",
  "pages.login.loginWith": "Login with :",
  "pages.login.registerAccount": "Register Account",
  "pages.welcome.link": "Welcome",
  "pages.welcome.alertMessage":
    "Faster and stronger heavy-duty components have been released.",
  "pages.404.subTitle": "Sorry, the page you visited does not exist.",
  "pages.404.buttonText": "Back Home",
  "pages.admin.subPage.title": "This page can only be viewed by Admin",
  "pages.admin.subPage.alertMessage":
    "Umi ui is now released, welcome to use npm run ui to start the experience.",
  "pages.searchTable.createForm.newRule": "New Rule",
  "pages.searchTable.updateForm.ruleConfig": "Rule configuration",
  "pages.searchTable.updateForm.basicConfig": "Basic Information",
  "pages.searchTable.updateForm.ruleName.nameLabel": "Rule Name",
  "pages.searchTable.updateForm.ruleName.nameRules":
    "Please enter the rule name!",
  "pages.searchTable.updateForm.ruleDesc.descLabel": "Rule Description",
  "pages.searchTable.updateForm.ruleDesc.descPlaceholder":
    "Please enter at least five characters",
  "pages.searchTable.updateForm.ruleDesc.descRules":
    "Please enter a rule description of at least five characters!",
  "pages.searchTable.updateForm.ruleProps.title": "Configure Properties",
  "pages.searchTable.updateForm.object": "Monitoring Object",
  "pages.searchTable.updateForm.ruleProps.templateLabel": "Rule Template",
  "pages.searchTable.updateForm.ruleProps.typeLabel": "Rule Type",
  "pages.searchTable.updateForm.schedulingPeriod.title":
    "Set Scheduling Period",
  "pages.searchTable.updateForm.schedulingPeriod.timeLabel": "Starting Time",
  "pages.searchTable.updateForm.schedulingPeriod.timeRules":
    "Please choose a start time!",
  "pages.searchTable.titleDesc": "Description",
  "pages.searchTable.ruleName": "Rule name is required",
  "pages.searchTable.titleCallNo": "Number of Service Calls",
  "pages.searchTable.titleStatus": "Status",
  "pages.searchTable.nameStatus.default": "default",
  "pages.searchTable.nameStatus.running": "running",
  "pages.searchTable.nameStatus.online": "online",
  "pages.searchTable.nameStatus.abnormal": "abnormal",
  "pages.searchTable.titleUpdatedAt": "Last Scheduled at",
  "pages.searchTable.exception": "Please enter the reason for the exception!",
  "pages.searchTable.titleOption": "Option",
  "pages.searchTable.config": "Configuration",
  "pages.searchTable.subscribeAlert": "Subscribe to alerts",
  "pages.searchTable.title": "Enquiry Form",
  "pages.searchTable.new": "New",
  "pages.searchTable.chosen": "chosen",
  "pages.searchTable.item": "item",
  "pages.searchTable.totalServiceCalls": "Total Number of Service Calls",
  "pages.searchTable.tenThousand": "0000",
  "pages.searchTable.batchDeletion": "batch deletion",
  "pages.searchTable.batchApproval": "batch approval",
  // Conversations
  "pages.conversations.list.title": "AI Conversation List",
  "pages.conversations.list.search.placeholder": "Search conversations...",
  "pages.conversations.detail.title": "Conversation Detail",
  "pages.conversations.status.active": "Active",
  "pages.conversations.status.archived": "Archived",
  "pages.conversations.status.deleted": "Deleted",
  "pages.conversations.tone.caring": "Caring",
  "pages.conversations.tone.cheeky": "Cheeky",
  "pages.conversations.tone.clinical": "Clinical",
  "pages.conversations.tone.concise": "Concise",
  "pages.conversations.tone.motivational": "Motivational",
  "pages.conversations.column.id": "ID",
  "pages.conversations.column.user": "User",
  "pages.conversations.column.title": "Title",
  "pages.conversations.column.status": "Status",
  "pages.conversations.column.tone": "Tone",
  "pages.conversations.column.lastMessage": "Last Message",
  "pages.conversations.column.createdAt": "Created At",
  "pages.conversations.column.actions": "Actions",
  "pages.conversations.filter.status": "Filter by Status",
  "pages.conversations.filter.userId": "Filter by User ID",
  "pages.conversations.filter.all": "All",
  "pages.conversations.viewDetail": "View Detail",
  "pages.shop-settings.title": "Shop Settings",
  "pages.shop-settings.subtitle": "Configure checkout features for the mobile shop",
  "pages.shop-settings.vat_invoice_enabled": "VAT Invoice Information",
  "pages.shop-settings.vat_invoice_enabled_desc":
    "When enabled, customers can request a VAT invoice during checkout.",
  "pages.shop-settings.load_failed": "Failed to load shop settings",
  "pages.shop-settings.save_success": "Shop settings updated",
  "pages.shop-settings.save_failed": "Failed to update shop settings",
  "pages.shop-settings.vn_admin_title": "Province / Ward Data",
  "pages.shop-settings.vn_admin_desc":
    "Re-import 34 provinces and wards from provinces.open-api.vn (API v2). Use this after administrative reforms or when the mobile address picker shows empty wards.",
  "pages.shop-settings.vn_admin_sync_button": "Sync province / ward data",
  "pages.shop-settings.vn_admin_sync_confirm":
    "Replace all province and ward data in the system with the latest from provinces.open-api.vn?",
  "pages.shop-settings.vn_admin_sync_confirm_ok": "Sync",
  "pages.shop-settings.vn_admin_sync_confirm_cancel": "Cancel",
  "pages.shop-settings.vn_admin_sync_success":
    "Synced {provinces} provinces and {wards} wards",
  "pages.shop-settings.vn_admin_sync_failed": "Failed to sync province / ward data",
  "pages.system-config.title": "System Configuration",
  "pages.system-config.subtitle": "Mobile maintenance mode and food search reindex",
  "pages.system-config.maintenance_title": "Maintenance Mode (Mobile)",
  "pages.system-config.maintenance_mode": "Enable maintenance",
  "pages.system-config.maintenance_mode_desc":
    "When enabled, the mobile app shows a maintenance screen and blocks users.",
  "pages.system-config.message_code": "Maintenance message code",
  "pages.system-config.message_code_desc":
    "Mobile app resolves localized copy from this code via i18n bundles.",
  "pages.system-config.message_code.default": "Default maintenance",
  "pages.system-config.message_code.upgrade": "System upgrade",
  "pages.system-config.message_code.scheduled": "Scheduled maintenance",
  "pages.system-config.estimated_end": "Estimated completion",
  "pages.system-config.save_button": "Save configuration",
  "pages.system-config.on": "On",
  "pages.system-config.off": "Off",
  "pages.system-config.load_failed": "Failed to load system configuration",
  "pages.system-config.save_success": "System configuration updated",
  "pages.system-config.save_failed": "Failed to update system configuration",
  "pages.system-config.es_title": "Elasticsearch — Food search",
  "pages.system-config.es_desc":
    "Reindex all foods from food_translations (display_name). This may take several minutes.",
  "pages.system-config.reindex_button": "Reindex Elasticsearch",
  "pages.system-config.reindex_confirm":
    "Recreate the foods index and reindex all foods?",
  "pages.system-config.reindex_confirm_ok": "Reindex",
  "pages.system-config.reindex_confirm_cancel": "Cancel",
  "pages.system-config.reindex_failed": "Elasticsearch reindex failed",
};
